var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisionBenefitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16C30 23.1797 24.1797 29 17 29C9.8203 29 4 23.1797 4 16C4 8.8203 9.8203 3 17 3C24.1797 3 30 8.8203 30 16Z",
    fill: "#D9E2FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.081 16.8717C9.53738 14.6615 7.08718 12.8673 3.71472 12L3 14.8277C5.52281 15.4766 7.29377 16.7212 8.44099 18.1816C6.91328 19.1583 5.74689 20.331 5.21671 21.2967C4.33147 22.9091 4.08252 24.4712 4.4478 25.8319C4.81346 27.1939 5.75313 28.1805 6.88509 28.6627C8.0057 29.14 9.33407 29.1307 10.4892 28.5064C11.6701 27.8682 12.5214 26.6719 12.8485 25.0611C13.2114 23.2736 13.0825 21.3325 12.4295 19.49C14.0136 18.9787 15.8249 18.8373 17.7022 19.4387C20.1121 20.2106 22.8712 22.2835 25.4838 26.9287L28 25.4886C25.14 20.4037 21.8729 17.7128 18.5778 16.6574C15.8272 15.7763 13.2248 16.0886 11.081 16.8717ZM9.80353 20.7674C10.1936 22.0221 10.2511 23.3099 10.0144 24.4756C9.83277 25.37 9.43524 25.7654 9.12297 25.9342C8.78497 26.1168 8.37587 26.13 8.01051 25.9744C7.65649 25.8235 7.36167 25.5217 7.24015 25.0691C7.11826 24.6151 7.12944 23.8362 7.74745 22.7105C7.97344 22.2989 8.6886 21.5132 9.80353 20.7674Z",
    fill: "#FB6F55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1454 17.4459C25.4399 17.4459 28.4103 15.5047 30.5476 12.1448C31.3875 10.8289 31.3875 8.61701 30.5476 7.30108C28.4103 3.94124 25.4399 2 22.1454 2C18.8509 2 15.8901 3.94124 13.7529 7.30108C13.0132 8.46393 12.6398 10.9502 13.4798 12.2662C15.617 15.626 18.8509 17.4459 22.1454 17.4459Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.487 9.72765C25.487 11.5756 23.9938 13.0688 22.1459 13.0688C20.2979 13.0688 18.8047 11.5756 18.8047 9.72765C18.8047 7.87974 20.2979 6.38647 22.1459 6.38647C23.9938 6.38647 25.487 7.87974 25.487 9.72765Z",
    fill: "#004BA3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2118 9.46631C23.2789 4.33322 15.5015 7.75526 13.0127 9.93293C13.0127 7.13309 15.8126 2 22.3456 2C28.8786 2 31.0563 7.13308 31.2118 9.46631Z",
    fill: "#F9DAD2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 10.8662C20.933 15.9993 28.7104 12.5773 31.1992 10.3996C31.1992 13.1994 28.3994 18.3325 21.8663 18.3325C15.3333 18.3325 13.1556 13.1994 13.0001 10.8662Z",
    fill: "#F9DAD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionBenefitLogo);
export default __webpack_public_path__ + "static/media/VisionBenefitLogo.88959b6bf12cdfd150ca731836c6ed0f.svg";
export { ForwardRef as ReactComponent };